import { useState } from "react";
import { notification } from "antd";
import { countFetch } from "@/apis/inventoryv2";
import { CountOrder } from "@/types/inventoryV2";
import errorCodes from "@/apis/error";
import { ScanCodeItem } from "@/types/scan";

type FetchDetails = (id: string) => Promise<void>
type IUseCountingFetch = () => [boolean, CountOrder | null, { fetchDetails: FetchDetails, setDetail: (detail: CountOrder) => void }]
const useCountingFetch: IUseCountingFetch = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [detail, setDetail] = useState<CountOrder | null>(null)

  const fetchDetails: FetchDetails = (id) => {
    setLoading(true)
    return new Promise((resolve, reject) => {
      countFetch(id)
        .then((res) => {
          // CountOrder不再有scans属性，直接设置detail
          setDetail(res)
          resolve()
        })
        .catch((err) => {
          console.error(err)
          notification.error({ placement: 'top', message: errorCodes[err] || err })
        })
        .finally(() => {
          setLoading(false)
        })
    })
  }

  return [loading, detail, { fetchDetails, setDetail }]
}

export default useCountingFetch;